import { combineReducers } from 'redux';

import {featureReducer, postFeatureReducer, putFeatureReducer} from './features';

export const Reducers = combineReducers({
  feature: featureReducer,
  post_feature: postFeatureReducer,
  put_feature: putFeatureReducer
});